'use client';

import { pathNameToPageName, usePathname } from '@/i18n/routing';
import { useEffect, useState } from 'react';
import useAmplitudeContext from '@/hooks/useAmplitudeContext';
import { AMPLITUDE_EVENTS } from '@/context/AmplitudeContext';

const getTS = () => Math.round(+new Date / 1000);

export function PageInteractionTracker() {
    const path = usePathname();
    const [prevState, setPrevState] = useState({
        path,
        ts: getTS()
    });
    const { trackEvent } = useAmplitudeContext();

    useEffect(() => {
        const currentTS = getTS();
        const diff = currentTS - prevState.ts;

        if (diff == 0) {
            return;
        }

        trackEvent(AMPLITUDE_EVENTS.PAGE_INTERACTION_DURATION, {
            href: prevState.path,
            duration: diff,
            page: pathNameToPageName(prevState.path)
        });

        setPrevState({
            path,
            ts: currentTS
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path]);

    useEffect(() => {
        window.onbeforeunload = () => {
            const currentTS = getTS();
            const diff = currentTS - prevState.ts;

            trackEvent(AMPLITUDE_EVENTS.PAGE_INTERACTION_DURATION, {
                href: path,
                duration: diff,
                page: pathNameToPageName(path)
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [path, prevState.ts]);

    return null;
}
